import React from "react";
import { CourseItem } from "service/service";

interface CourseContextProps {
    course: CourseItem;
    basename: string;
    path: string;
    updateCourses: () => Promise<void>;
}

export const CourseContext = React.createContext<CourseContextProps>({
    course: {} as CourseItem,
    basename: "",
    path: "",
    updateCourses: () => Promise.resolve()
});
